var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function NextForecastWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.duration = ko.observable(null);
  self.name = 'NextForecastWS';			// Convenience name for debugging
  self.units = ko.observable(null);


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/queues/' + self.parent.id + '/forecast/next';
  });


	/**
   * Overload to prevent service from being called before the QueueID
   * has been set
	 *
	 * @method doRequest
	 * @param {Function} fCallback
	 * @returns none
	 */
  self.doRequest = function (fCallback) {
    if (self.parent.id !== -1) {
      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };


	/**
	 * Parses XML data for duration and units
	 *
	 * @method parseWaitTime
	 * @param {XMLNode} xmlData
	 * @returns {Object}
	 */
  self.parseWaitTime = function (xmlData) {
    var obj = {};
    var json = xmlToJson.parse(xmlData);

    if (xmlData && json) {
      var waitTime = json.waitTimes && json.waitTimes.waitTime;

      if (waitTime != null) {
        obj.duration = Number(waitTime.duration) * 1;
        obj.units = waitTime.units;
      }
    }

    return obj;
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {LocationsWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    var waitTime = null;

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    waitTime = self.parseWaitTime(xmlData);

    self.duration(waitTime.duration);
    self.units(waitTime.units);

    return self;
  };


	/**
	 * Returns the object to it's initial state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    // Remove any queues
    self.spots.removeAll();

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);
  };

  return self;
};

NextForecastWS.prototype = AbstractWS.prototype;
NextForecastWS.prototype.constructor = NextForecastWS;

module.exports = NextForecastWS;
